export enum TwilioChannel {
  SMS = 'sms',
  CALL = 'call',
  WHATSAPP = 'whatsapp'
}
